const Defaults = {
  LoadState: 'preload',
  CropValue: -1,
  LocalFileRead: true,
}

export default Defaults
